<div class="loader-container">
    <app-loader *ngIf="loading == true"></app-loader>
    <section>
        <div *ngIf="errorMessage" class="alert alert-danger d-flex align-items-center" role="alert">
            <div>
                {{errorMessage}}
            </div>
        </div>

        <div class="col-span-12 md:col-span-6">
            <div class="mb-3">
                <label class="form-label">Titel</label> 
                <input 
                    [ngClass]="{'is-invalid': errors['title']}"
                    type="text" 
                    [(ngModel)]="item['title']" 
                    class="form-control" 
                    placeholder="Titel methode">
            </div>
        </div>

        <div class="col-span-12 md:col-span-6">
            <div class="mb-3">
                <label class="form-label">Korte code</label> 
                <input 
                    [ngClass]="{'is-invalid': errors['code']}"
                    type="text" 
                    [(ngModel)]="item['code']" 
                    class="form-control">
            </div>
        </div>
        
        <div class="col-span-12 md:col-span-6">
            <div class="mb-3">
                <label class="form-label">Actief</label> 
                <div class="d-flex">
                    <div class="form-check me-5">
                        <input class="form-check-input" id="active_yes" type="radio" name="active" [(ngModel)]="item['active']" [value]="1"> 
                        <label class="form-check-label" for="active_yes">Actief</label>
                    </div>
                    <div class="form-check">
                        <input class="form-check-input" id="active_no" type="radio" name="active" [(ngModel)]="item['active']" [value]="0"> 
                        <label class="form-check-label" for="active_no">Niet actief</label>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-span-12 md:col-span-6">
            <div class="mb-3">
                <label class="form-label">URL</label> 
                <input 
                    [ngClass]="{'is-invalid': errors['url']}"
                    type="text" 
                    [(ngModel)]="item['url']" 
                    class="form-control">
            </div>
        </div>

        <div class="col-span-12 md:col-span-6">
            <div class="mb-3">
                <label class="form-label">Endpoint</label> 
                <input 
                    [ngClass]="{'is-invalid': errors['endpoint']}"
                    type="text" 
                    [(ngModel)]="item['endpoint']" 
                    class="form-control">
            </div>
        </div>

        <div class="col-span-12 md:col-span-6">
            <div class="mb-3">
                <label class="form-label">Client</label> 
                <input 
                    [ngClass]="{'is-invalid': errors['client']}"
                    type="text" 
                    [(ngModel)]="item['client']" 
                    class="form-control">
            </div>
        </div>

        <div class="col-span-12 md:col-span-6">
            <div class="mb-3">
                <label class="form-label">Secret</label> 
                <input 
                    [ngClass]="{'is-invalid': errors['secret']}"
                    type="text" 
                    [(ngModel)]="item['secret']" 
                    class="form-control">
            </div>
        </div>

        <div class="form-buttons">
		    <button type="button" class="btn btn-primary" (click)="save()">Opslaan</button>
        </div>
    </section>
</div>